type ErrorBody = {
  error?: string | null;
  message?: string | null;
  errors?: string[] | null;
};

// API はハンドラによって errors / message / error を返し分けるため、表示できるものを拾う
export default async function parseBoardResponse<T>(
  response: Response,
  fallbackMessage: string
): Promise<T> {
  if (response.ok) return (await response.json()) as T;

  const body: ErrorBody = await response.json().catch(() => ({}));
  const detail = body.errors?.join(' / ') || body.message || body.error;
  throw new Error(detail || fallbackMessage);
}
